"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M13.7375 3.049c.0538-.2152-.2306-.345-.3579-.1631L7.3321 11.525a.5.5 0 0 0 .186.734l3.1653 1.5826a.5.5 0 0 1 .2725.5092l-.8386 6.7088c-.0268.2146.2587.3132.37.1278l5.2347-8.7246a.5.5 0 0 0-.2051-.7045l-3.1584-1.5791a.5.5 0 0 1-.2614-.5685l1.6404-6.5617Z", clipRule: "evenodd" })), 'LightningIcon');
